import type { SchedulerTypeKey } from '@jarvis/platform-ui';

interface LegendType {
  id: SchedulerTypeKey;
  color: string;
  text: SchedulerTypeKey;
}

export interface TimeOffCalendarLegendProps {
  typeColors: LegendType[];
  /** Compact, horizontally-scrollable variant for narrow/mobile chrome. */
  compact?: boolean;
}

export function TimeOffCalendarLegend({ typeColors, compact = false }: TimeOffCalendarLegendProps) {
  return (
    <div
      className={`time-off-calendar-legend${compact ? ' time-off-calendar-legend--compact' : ''}`}
      aria-label="Leave type colors"
    >
      {typeColors.map((type) => (
        <span key={type.id} className="time-off-calendar-legend__item">
          <span className="time-off-calendar-legend__swatch" style={{ backgroundColor: type.color }} aria-hidden />
          <span>{type.text}</span>
        </span>
      ))}
    </div>
  );
}
